import React, { useState, useEffect }  from "react";

/* ***********************
**   Import Material-UI
*********************** */
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import Web3 from "web3";

/* ***********************
**   Import images
*********************** */
import logo from '../../../src/img/logofinal.png'


var web3;

var accounts = [];
let finalAccount;

const Menu = () =>{
    const [useWallet,setWallet] = useState('Connect');

    /***************************************************
     *
     *    Slicing functions
     *
     ****************************************************/
  
    const  connectWallat = () =>{
        //if metamask is installed
        if(window.web3 !== undefined){
            //connect to web3
            web3 = new Web3(window.ethereum);
            // gasPrice's contract's credentials

            window.ethereum.request({ method: 'eth_requestAccounts' }).then(_accounts => {
                accounts = _accounts;
                finalAccount = accounts.toString();

                const start_char = finalAccount.toString().substring(0,5)+".....";
                const end_char = finalAccount.toString().substr(finalAccount.length - 4);
                setWallet(start_char+end_char)
            });  
        }
        else{
            //if Metamask is not installed
        }
    }
    useEffect(()=> {
       
        connectWallat();
    },[accounts,finalAccount]);



    return(
        <div className="SCB---menu">
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                    xs={12}
                >
                    <Grid
                        xs={5}
                        sm={6}
                        style={{textAlign:'left'}}
                    >
                        <a href="/">
                            <img src={logo} style={{height:60, width: 'auto'}} />
                        </a>
                    </Grid>
                    <Grid
                        xs={7}
                        sm={6}
                        style={{textAlign:'right'}}
                    >
                        {/* <button href='#' onClick={connectWallat} title={useWallet} >{ useWallet }</button> */}
                        <a className="btn" href="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428" target="_blank">BUY NOW</a>
                        {/* <a className="btn" href="https://v1exchange.pancakeswap.finance/#/swap?outputCurrency=0xf0ab4b8daa51f6abf6b4c9fef0cca5d127029aa9" target="_blank">BUY $SBD</a> */}
                        <button className="btn SCB-d-none-sm" onClick={connectWallat}>{useWallet}</button>
                    </Grid>

                    <Grid
                        xs={12}
                        style={{textAlign:'right'}}
                    >
                        <button className="btn SCB-d-none-md" onClick={connectWallat}>{useWallet}</button>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Menu;